import { Injectable, inject } from '@angular/core';
import { CreditCardGatewayApi } from 'api-typings/payments/payments';
import { AdyenThreeDSHandler } from './adyen';
import type { ThreeDSHandler } from './three-ds.types';

/**
 * Factory for returning the correct 3DS handler based on the payment gateway
 */
@Injectable({
  providedIn: 'root',
})
export class ThreeDSFactory {
  private readonly adyenHandler = inject(AdyenThreeDSHandler);

  /**
   * Get the appropriate 3DS handler based on the gateway
   *
   * @param gateway The payment gateway identifier string
   * @returns The corresponding 3DS handler
   * @throws Error if the gateway is not supported
   */
  getHandler(gateway: string): ThreeDSHandler {
    switch (gateway.toLowerCase()) {
      case CreditCardGatewayApi.ADYEN:
        return this.adyenHandler;
      default:
        throw new Error(`Unsupported 3DS gateway: ${gateway}`);
    }
  }
}
